import { useEffect, useState } from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { useTranslations } from "../hooks/useTranslations";
import { useMe } from "../http/serviceportalApi";
import SVGDescription from "../icons/Description.svg?react";
import SVGFactCheck from "../icons/FactCheck.svg?react";
import { checkHasEconomicAdvisorPermission } from "../utils";
import AccountButton from "./AccountButton";
import styles from "./EconomicAdvisorApp.module.css";
import EconomicAdvisorDocuments from "./EconomicAdvisorDocuments";
import EconomicAdvisorQuestionnaire from "./EconomicAdvisorQuestionnaire";
import Sidebar from "./Sidebar";
import AppMenu from "./ui/AppMenu";
import Hamburger from "./ui/Hamburger";
import LoadingSpinner from "./ui/LoadingSpinner";
import Nav from "./ui/Nav";

const EconomicAdvisorApp = () => {
  const { i18n } = useTranslations();
  const auth = useAuth();
  const matchesMedia = useMediaQuery("(min-width: 1400px)");
  const [isSidebarOpen, setSidebarOpen] = useState(matchesMedia);

  const { data, isValidating } = useMe();
  const userPermissions = data?.permissions ?? [];

  const isEconomicAdvisor = checkHasEconomicAdvisorPermission(userPermissions);

  const closeMenu = () => {
    !matchesMedia && setSidebarOpen(false);
  };

  useEffect(closeMenu, [matchesMedia]);

  if (!auth.session || !isEconomicAdvisor) {
    return null;
  }

  return isValidating ? (
    <div className={styles.loadingSpinner}>
      <LoadingSpinner />
    </div>
  ) : (
    <>
      <header className={styles.header}>
        <div className={styles.aside}>
          <Hamburger
            isOpen={isSidebarOpen}
            className={styles.hamburger}
            onClick={() => setSidebarOpen(!isSidebarOpen)}
          />
          <Link to="/wirtschaftsberater" className={styles.logo}>
            {i18n.economicAdvisorApp.title}
          </Link>
        </div>
        <AppMenu />
        <AccountButton />
      </header>
      <div>
        <Sidebar isOpen={isSidebarOpen} close={closeMenu}>
          <Nav>
            <Nav.Item
              text={i18n.documents.title}
              to="dokumente"
              icon={SVGDescription}
              onClick={closeMenu}
            />
            <Nav.Item
              text={i18n.economicAdvisorApp.questionnaire.title}
              to="modell-cu-770"
              icon={SVGFactCheck}
              onClick={closeMenu}
            />
          </Nav>
        </Sidebar>
        <Routes>
          <Route
            path="modell-cu-770/*"
            element={<EconomicAdvisorQuestionnaire />}
          />
          <Route path="dokumente/*" element={<EconomicAdvisorDocuments />} />
          <Route path="*" element={<Navigate to="dokumente" replace />} />
        </Routes>
      </div>
    </>
  );
};

export default EconomicAdvisorApp;
